import React from "react";
import { Link } from "react-router";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  Button,
} from "reactstrap";
import IconLogout from "react-icons/lib/md/power-settings-new";

// style
import "./style.css";
import { getRequest } from "../../../utils/apiUtils";
import asepsisLogo from "../../../assets/images/asepsis-logo.png";

export default class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first_name: "",
    };
  }

  componentDidMount() {
    var that = this;
    getRequest({ url: "api/get_user_data/"})
      .then(function (response) {
        if (response.data != "") {
          that.setState({
            first_name: response.data.first_name,
          });
        }
      })
      .catch(function (error) {
        if (error.response) {
          if (error.response.status === 403) {
            // Handle unauthorized access
          } else {
            console.error("Error fetching user data:", error);
          }
        } else {
          console.error("Error fetching user data:", error);
        }
      });
  }

  render() {
    return (
      <>
        <header className="site-head">
          <div className="header-branding">
            <div className="brand-logo-wrapper">
              <img src={asepsisLogo} alt="ASEPSIS - Aged Care Standard" className="logo-image" />
            </div>
          </div>
          <div className="right-elems">
            <div className="wrap profile">
              <UncontrolledDropdown>
                <DropdownToggle tag="div">
                  <div className="user-chip">
                    <img src="/icon.jpg" alt="avatar" className="user-avatar"/>
                    <div>
                      <div className="user-date">
                        {new Date().toLocaleDateString('en-US', { weekday: 'long', day: '2-digit', month: 'long', year: 'numeric' })}
                      </div>
                      <div className="welcome-text">
                        Welcome, {this.state.first_name}
                      </div>
                    </div>
                  </div>
                </DropdownToggle>
                <DropdownMenu
                  right
                  className="user-dropdown-menu"
                >
                  <div className="logout-wrapper">
                    <Link to="/" onClick={this.props.logout}>
                      <Button block className="logout-btn">
                        <IconLogout size="16" />
                        <span>Logout</span>
                      </Button>
                    </Link>
                  </div>
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          </div>
        </header>
      </>
    );
  }
}
